import { create } from 'zustand';

const PANEL_STATE_KEY = 'leftPanelState';

const getInitialState = () => {
  const savedState = localStorage.getItem(PANEL_STATE_KEY);
  if (savedState) {
    const parsed = JSON.parse(savedState);
    // Support migration from old formats
    if (typeof parsed === 'boolean') {
      // Old format: true = expanded, false = collapsed
      return { collapsed: !parsed };
    }
    // Support old three-state format (visible + collapsed)
    if (parsed.visible !== undefined) {
      // If was hidden, default to collapsed
      // If was visible, preserve collapsed state
      return { collapsed: parsed.visible ? parsed.collapsed : true };
    }
    // New two-state format
    return parsed;
  }
  return { collapsed: false };
};

const usePanelState = create((set, get) => ({
  ...getInitialState(),
  setIsExpanded: (expanded) => {
    const newState = { collapsed: !expanded };
    localStorage.setItem(PANEL_STATE_KEY, JSON.stringify(newState));
    set(newState);
  },
  setCollapsed: (collapsed) => {
    const newState = { collapsed };
    localStorage.setItem(PANEL_STATE_KEY, JSON.stringify(newState));
    set(newState);
  },
  toggle: () => {
    const current = get();
    const newState = { collapsed: !current.collapsed };
    localStorage.setItem(PANEL_STATE_KEY, JSON.stringify(newState));
    set(newState);
  },
  // Backwards compatibility: computed property
  get isExpanded() {
    const state = get();
    return !state.collapsed;
  },
  // Backwards compatibility: always visible now
  get visible() {
    return true;
  }
}));

// Maintain backwards compatibility with existing code
export const getPanelState = () => {
    const state = getInitialState();
    if (typeof state === 'boolean') {
        return state;
    }
    // Old format had visible property
    if (state.visible !== undefined) {
        return state.visible && !state.collapsed;
    }
    // New format: just check collapsed
    return !state.collapsed;
};

export const savePanelState = (isOpen) => {
    usePanelState.getState().setIsExpanded(isOpen);
};

export { usePanelState };
